import apiClient from "./apiClient";
import apiClientMulti from "./apiClientMulti";
import { AxiosResponse } from "axios";
import axios from "axios";
import {
  FileDetailsResponse,
  FileDetailsRequest,
} from "./Models/DocumentsModel";
import { uploadFileRequest } from "./Models/FileModel";

const baseWCFUrl: string = window.config.BASE_URL + "/api";

export const downloadFile = (
  fileName: string,
  idObject: number,
  idDoc: number,
  MD5: string,
  show: boolean,
  tipoDocumento: string
) => {
  let url = "";
  if ((tipoDocumento === "LINK" || tipoDocumento === "YOUTUBE") && show)
    url = fileName;
  else {
    url = `${baseWCFUrl}/DownloadFile/ExecuteDownloadFile?FileName=${encodeURIComponent(
      fileName
    )}&IdObject=${encodeURIComponent(idObject)}&IdDoc=${encodeURIComponent(
      idDoc
    )}&MD5=${encodeURIComponent(MD5)}`;
  }
  if (show && tipoDocumento !== "LINK" && tipoDocumento !== "YOUTUBE")
    url += `&tryOpenFile=true`;
  if (show && tipoDocumento === "YOUTUBE") url += `?autoplay=1`;
  window.open(url, "_blank");
};

export const getUrlPreview = (
  fileName: string,
  idObject: number,
  idDoc: number,
  MD5: string,
  show: boolean
) => {
  const url: string = `${baseWCFUrl}/DownloadFile/ExecuteDownloadFile?FileName=${encodeURIComponent(
    fileName
  )}&IdObject=${encodeURIComponent(idObject)}&IdDoc=${encodeURIComponent(
    idDoc
  )}&MD5=${encodeURIComponent(MD5)}&tryOpenFile=true`;
  return url;
};

export const uploadFile = async (
  securityToken: string,
  idObject: number,
  fileName: string,
  description: string,
  file: any
): Promise<FileDetailsResponse> => {
  const formData = new FormData();
  formData.append("SecurityToken", securityToken); // Aggiungi il file
  formData.append("IdObject", String(idObject)); // Aggiungi il file
  formData.append("FileName", fileName); // Aggiungi il file
  formData.append("fileData", file as File); // Aggiungi il file
  formData.append("DeleteAllBeforeLoad", String(true)); // cancello tutti i file prima di uploadare la nuova immagine

  // const requestData: uploadFileRequest = {
  //   SecurityToken: securityToken,
  //   IdObject: idObject,
  //   FileName: fileName,
  //   Description: description,
  //   FileData: fileData,
  // };
  try {
    const response: AxiosResponse<FileDetailsResponse> =
      await apiClientMulti.post("/FileDetails/DocumentUploadPost", formData);
    return response.data;
  } catch (error) {
    console.error("GetSiteParameters Error:", error);
    throw error;
  }
};

export const deleteFile = async (
  securityToken: string,
  idObject: number,
  idDoc: number
): Promise<FileDetailsResponse> => {
  const requestData: FileDetailsRequest = {
    SecurityToken: securityToken,
    IdObject: idObject,
    IdDoc: idDoc,
  };

  try {
    const response: AxiosResponse<FileDetailsResponse> = await apiClient({
      method: "post",
      url: "/FileDetails/DeleteFile",
      data: requestData,
    });
    return response.data;
  } catch (error) {
    console.error("deleteFile Error:", error);
    throw error;
  }
};

export const documentSave = async (
  securityToken: string,
  idObject: number,
  idDoc: number,
  descrizione: string
): Promise<FileDetailsResponse> => {
  const requestData: FileDetailsRequest = {
    SecurityToken: securityToken,
    IdObject: idObject,
    IdDoc: idDoc,
    Description: descrizione,
  };

  try {
    const response: AxiosResponse<FileDetailsResponse> = await apiClient({
      method: "post",
      url: "/FileDetails/DocumentSave",
      data: requestData,
    });
    return response.data;
  } catch (error) {
    console.error("documentSave Error:", error);
    throw error;
  }
};
